import React from "react"
import IconButton from "@mui/material/IconButton"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import LightTooltip from "../../components/LightTooltip"

export const getLastClickTime = () => lastClickTime
let lastClickTime = Date.now()

export default function Tooltip({children, id}) {
    const toClipboard = async () => {
        // event.stopPropagation() doesn't work because Tooltip is using a Portal
        lastClickTime = Date.now()
        await navigator.clipboard.writeText(id)
    }

    return (
        <LightTooltip title={<span className="flexRow center">
			{id}&nbsp;&nbsp;
            <IconButton onClickCapture={toClipboard}><ContentCopyIcon/></IconButton>
		</span>
        } placement="top">
            {children}
        </LightTooltip>
    )
}